"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAddressStringFromAddressObject = createAddressStringFromAddressObject;
exports.getAddressObjectFromFormValues = getAddressObjectFromFormValues;
exports.getFormInitialValuesFromAddress = getFormInitialValuesFromAddress;
exports.getSelectOptionsFromAddressSearchArray = getSelectOptionsFromAddressSearchArray;
exports.mapLoqateAddressValuesToAddress = mapLoqateAddressValuesToAddress;
var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _replaceInvalidCharacters = _interopRequireDefault(require("../../form/normalizers/replaceInvalidCharacters"));
var _transformUkPhoneNumber = _interopRequireDefault(require("../../form/normalizers/transformUkPhoneNumber"));
var _isArray = _interopRequireDefault(require("../../utils/core/isArray"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getFormInitialValuesFromAddress() {
  var addressObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = addressObject.id || '';
  var address = addressObject.address || {};
  var addressee = addressObject.addressee || {};
  var postcode = address.postcode ? {
    postcode: address.postcode
  } : {};
  var phoneNumber = addressObject.phoneNumber ? {
    phoneNumber: addressObject.phoneNumber
  } : {};
  var initialValues = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    id: id
  }, addressee), address), postcode), phoneNumber);
  return Object.keys(initialValues).reduce(function (acc, key) {
    return initialValues[key] ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, (0, _replaceInvalidCharacters["default"])(initialValues[key]))) : acc;
  }, {});
}
function createAddressStringFromAddressObject() {
  var addressObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!(0, _isPlainObject["default"])(addressObject)) {
    return addressObject;
  }
  return Object.keys(addressObject).reduce(function (acc, key, index) {
    if (addressObject[key] && key !== 'countryCode') {
      var comma = index > 0 ? ', ' : '';
      return "".concat(acc).concat(comma).concat(addressObject[key]);
    }
    return acc;
  }, '');
}
function getSelectOptionsFromAddressSearchArray() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!(0, _isArray["default"])(array)) {
    return array;
  }
  return array.map(function (item, index) {
    return {
      value: index,
      label: createAddressStringFromAddressObject(item)
    };
  });
}
function getAddressObjectFromFormValues() {
  var formValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var title = formValues.title,
    firstName = formValues.firstName,
    lastName = formValues.lastName,
    addressLine1 = formValues.addressLine1,
    addressLine2 = formValues.addressLine2,
    addressLine3 = formValues.addressLine3,
    addressLine4 = formValues.addressLine4,
    townOrCity = formValues.townOrCity,
    countyStateOrProvince = formValues.countyStateOrProvince,
    postcode = formValues.postcode,
    countryCode = formValues.countryCode,
    phoneNumber = formValues.phoneNumber;
  return {
    addressee: {
      title: title,
      firstName: firstName,
      lastName: lastName
    },
    address: {
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      addressLine3: addressLine3,
      addressLine4: addressLine4,
      townOrCity: townOrCity,
      countyStateOrProvince: countyStateOrProvince,
      postcode: postcode,
      countryCode: countryCode
    },
    phoneNumber: countryCode === 'GB' ? (0, _transformUkPhoneNumber["default"])(phoneNumber) : phoneNumber
  };
}
function mapLoqateAddressValuesToAddress() {
  var loqateValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var combineExtraAddressLines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var Line1 = loqateValues.Line1,
    Line2 = loqateValues.Line2,
    Line3 = loqateValues.Line3,
    Line4 = loqateValues.Line4,
    Line5 = loqateValues.Line5,
    City = loqateValues.City,
    PostalCode = loqateValues.PostalCode,
    CountryIso2 = loqateValues.CountryIso2,
    Company = loqateValues.Company,
    DomesticId = loqateValues.DomesticId;
  if (Company) {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      addressLine1: Company
    }, Line1 && {
      addressLine2: Line1
    }), Line2 && {
      addressLine3: Line2
    }), combineExtraAddressLines && Line2 && !Line3 && {
      addressLine3: Line2
    }), combineExtraAddressLines && Line2 && Line3 && {
      addressLine3: "".concat(Line2, " ").concat(Line3)
    }), !combineExtraAddressLines && Line3 && {
      addressLine4: Line3
    }), !combineExtraAddressLines && Line4 && {
      addressLine5: Line4
    }), {}, {
      townOrCity: City,
      postcode: PostalCode,
      countryCode: CountryIso2,
      company: Company,
      domesticId: DomesticId
    });
  }
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Line1 && {
    addressLine1: Line1
  }), Line2 && {
    addressLine2: Line2
  }), !combineExtraAddressLines && Line3 && {
    addressLine3: Line3
  }), combineExtraAddressLines && Line3 && !Line4 && {
    addressLine3: Line3
  }), combineExtraAddressLines && Line3 && Line4 && {
    addressLine3: "".concat(Line3, " ").concat(Line4)
  }), !combineExtraAddressLines && Line4 && {
    addressLine4: Line4
  }), !combineExtraAddressLines && Line5 && {
    addressLine5: Line5
  }), {}, {
    townOrCity: City,
    postcode: PostalCode,
    countryCode: CountryIso2,
    company: Company,
    domesticId: DomesticId
  });
}